import { useState } from 'react'

import type { PaginationState } from '@gto/ui/data-table'

import { INITIAL_PAGINATION } from './constants'

/**
 * The server-paging state all three history tables share: the DS `PaginationState` the table
 * reads, and the 1-based `page` / `page_size` the API takes.
 *
 * Changing the page SIZE resets to the first page — a page index valid for 30 rows a page can
 * land past the last page at 100, which returns nothing and reads as an empty table.
 */
export const useHistoryPagination = () => {
  const [pagination, setPagination] = useState<PaginationState>(INITIAL_PAGINATION)

  return {
    pagination,
    onPaginationChange: (next: PaginationState) => {
      setPagination((prev) => ({
        ...next,
        pageIndex: next.pageSize === prev.pageSize ? next.pageIndex : 0,
      }))
    },
    /** Query params for the generated list hooks, which count pages from 1. */
    params: { page: pagination.pageIndex + 1, page_size: pagination.pageSize },
  }
}
